import { Card,  CardBody,  Col, Container, Input, Label, Row } from 'reactstrap'
import {  SearchTableButton, } from "../../../utils/Constant"
import Breadcrumbs from '../../../common-elements/breadcrumbs/Breadcrumbs'
import OrganizationListFilterHeader from './OrganizationListFilterHeader'
import CollapseFilterData from './CollapseFilterData'
import DataTable from "react-data-table-component";
import { productListTableData, productListTableDataColumn } from '../../../data/organization/OrganizationList'
import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { tableHeaderStyles } from '../../../styles/ReactSelectStyles'

const OraganizationListContainer = () => {
  const [filterText, setFilterText] = useState("");
  const {t}=useTranslation()
  
  const columns = productListTableDataColumn(t);


  const searchBar = useMemo(
    () => (
      <div className="d-flex align-items-center">
        <Label className="me-2">{t(SearchTableButton)}:</Label>
        <Input
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFilterText(e.target.value)}
          type="search"
          value={filterText}
          placeholder="Search...."
          style={{ maxWidth: '200px' }}  
        />
      </div>
    ),
    [filterText, t]
  );


  const filteredItems = productListTableData.filter((item) => item.industry && item.industry.toLowerCase().includes(filterText.toLowerCase()));

 

  return (
    <>
      <Breadcrumbs mainTitle={t("Organizations")} parent={t("Master Data")} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <div className="list-product-header">
                  <div className="header-container">
                  <div className="search-container">{searchBar}</div> 
                    <div className='actions-container'><OrganizationListFilterHeader /></div>  
                  </div>
                  <CollapseFilterData /> 
                </div>
                
                <div className="list-product">
                  <div className="table-responsive" >
                    <DataTable data={filteredItems} columns={columns}   customStyles={tableHeaderStyles} striped highlightOnHover pagination selectableRows />
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default OraganizationListContainer